// extracted by mini-css-extract-plugin
export var collapsedSummary = "_hj-0";